module.exports = __webpack_public_path__ + "img/grapheMesCompetences.8d621f9e.svg";